import withNavigation from "../components/withNavigation";
import { VIEW_BUNDLES } from "./screen";

const withNavigationToBundles = withNavigation([
  {
    text: "Back to Bundles",
    onNavigate: (props) => props.setScreen(VIEW_BUNDLES),
  }
]);

export default withNavigationToBundles;
